module.exports = __webpack_public_path__ + "img/mikecrack.400c8a0d.png";